import { createAction } from "@reduxjs/toolkit";

export const changeFilter = createAction("contacts/change_filter");
